import React, { useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";

// component
import Leftbar from "../common/leftbar/leftbar";
import CallingScreen from "../common/twilio/calling-screen";

// store
import { useDispatch, useSelector } from "react-redux";
import { removeCallData } from "../../reducer/slices/twilio-calls/call-slice";

// api
import { getLiveCallStatus } from "../../js/api/twilio";

// library
import axios from "axios";
import { Device } from "@twilio/voice-sdk";

// audio
import ringing_Audio from "../../assets/audio/ringtone.mp3";
import { removeViewData, setViewData } from "../../reducer/slices/twilio-calls/view-slice";
let ringingAudio = new Audio(ringing_Audio);

const MasterLayout = () => {
  const callValue = useSelector((state) => state.call);
  const callView = useSelector((state) => state.callView.callSizeData);
  const isCallInprogress = useSelector((state) => state.call.callData);
  const dispatch = useDispatch();
  const [trialInfo, setTrialInfo] = useState({});
  const [callingModal, setCallingModal] = useState(false);
  const [isMiniScreen, setIsMiniScreen] = useState(false);
  const [isTrialStatus, setIsTrialStatus] = useState(true);
  const [status, setStatus] = useState("Calling");
  const [isReady, setIsReady] = useState(false);
  const [callSid, setCallSid] = useState(null);
  const [mute, setMute] = useState(false);

  const user = useSelector((state) => state.user);
  const [connection, setConnection] = useState();
  const [callErrorMsg, setCallErrorMsg] = useState();
  let callDurationInterval = null;
  let elapsedSeconds = 0;
  const deviceRef = useRef(null);


  useEffect(() => {
    setCallingModal(callView.isMaxView);
    setIsMiniScreen(callView.isMinView);
  }, [callView]);

  const maximizeCall = () => {
    if (isCallInprogress && callView.isMinView === true)
      dispatch(
        setViewData({
          isMaxView: true,
          isMinView: false,
        })
      );
  };

  const getCallStatus = async (callSid) => {
    try {
      const status = await getLiveCallStatus(callSid);
      setStatus(
        status.data.status === "no-answer" ? "No Answer" : "Call ended"
      );
    } catch (error) {
    }
  };

  const setupTwilioDevice = async () => {
    try {
      const res = await axios.get("/api/twilioVoice/get-twilio-token");
      const token = res.data?.data?.token;

      if (!token) {
        throw new Error("No token received");
      }

      const twilioDevice = new Device(token, {
        codecPreferences: ["opus", "pcmu"],
        enableRingingState: true,
        debug: true,
      });

      twilioDevice.on("registered", () => {
        setIsReady(true);
      });

      twilioDevice.on("disconnect", () => {
        setStatus("Call ended");
        setCallSid("");
        if (callDurationInterval) {
          clearInterval(callDurationInterval);
          callDurationInterval = null;
        }
      });

      twilioDevice.on("error", (error) => {
      });

      await twilioDevice.register();

      deviceRef.current = twilioDevice;
    } catch (err) {
      setStatus(`Setup failed: ${err.message}`);
    }
  };

  useEffect(() => {
    setupTwilioDevice();
    return () => {
      deviceRef.current?.destroy();
    };
  }, []);

  const handleHangup = () => {
    dispatch(removeCallData());
    deviceRef.current?.disconnectAll();
    setStatus("Call ended");
  };

  const handleCall = async (data) => {
    setCallErrorMsg("");
    setStatus("Calling");
    if (!deviceRef.current || !isReady) {
      setStatus("Device not ready yet");
      return;
    }

    if (!data.phoneNumber) {
      setStatus("Please enter a phone number");
      return;
    }

    const params = {
      To: data.phoneNumber,
      PatientID: data.patientID,
      PatientTrialJuncID: data.patientTrialJuncID,
      UserID: user.userProfile.userID,
    };

    try {
      const connection = await deviceRef.current.connect({
        params: params,
      });

      setConnection(connection);
    } catch (error) {
      console.error("Call error:", error);
    }
  };

  useEffect(() => {
    const logConnection = async () => {
      const con = await connection;

      con.on("ringing", (hasEarlyMedia) => {
        if (!hasEarlyMedia) {
          setStatus("Ringing");
        }
        setCallSid(con?.parameters?.CallSid);
      });

      con.on("accept", () => {
        setCallSid(con?.parameters?.CallSid);
        elapsedSeconds = 0;
        callDurationInterval = setInterval(() => {
          elapsedSeconds++;
          const minutes = Math.floor(elapsedSeconds / 60);
          const seconds = elapsedSeconds % 60;
          const formattedSeconds = seconds.toString().padStart(2, "0");
          setStatus(`${minutes}:${formattedSeconds}`);
        }, 1000);
      });

      con.on("answered", () => {
        setCallSid(con?.parameters?.CallSid);
      });

      con.on("disconnect", async () => {
        await getCallStatus(con?.parameters?.CallSid);

        setCallSid("");
        if (callDurationInterval) {
          clearInterval(callDurationInterval);
          callDurationInterval = null;
        }
      });

      con.on("error", (error) => {
        if (error?.originalError?.message) {
          setCallErrorMsg(error.originalError.message);
        }
      });
    };

    if (connection) {
      logConnection();
    }
  }, [connection]);

  useEffect(() => {
    if (status === "Ringing") {
      ringingAudio.play().catch((err) => {
        console.warn("Ringtone play failed:", err);
      });
    } else {
      ringingAudio.pause();
      ringingAudio.currentTime = 0;
    }

    if (["Call ended", "No Answer"].includes(status)) {
      setTimeout(() => {
        setCallingModal(false);
        setIsTrialStatus(true);
        setIsMiniScreen(false);
        setStatus("");
        dispatch(removeCallData());
        dispatch(removeViewData())
      }, 2500);
    }
  }, [status]);

  const muteCall = () => {
    connection.mute(true);
    setMute(true);
  };

  const unMuteCall = () => {
    connection.mute(false);
    setMute(false);
  };

  useEffect(() => {
    if (callValue.callData) {
      setMute(false);
      const preTrialInfo = callValue.callData.trialInfo;
      handleCall(preTrialInfo);
      setTrialInfo(preTrialInfo);
      dispatch(
        setViewData({
          isMaxView: true,
          isMinView: false,
        })
      );
      setCallingModal(true);
    }
  }, [callValue]);

  return (
    <div className="flex">
      <Leftbar />
      <div className="grow h-screen overflow-auto py-1 pt-0 px-0">
        <Outlet />
        {callingModal && (
          <CallingScreen
            callSid={callSid}
            mute={mute}
            callErrorMsg={callErrorMsg}
            muteCall={muteCall}
            unMuteCall={unMuteCall}
            status={status}
            setStatus={setStatus}
            handleHangup={handleHangup}
            callingModal={callingModal}
            setCallingModal={setCallingModal}
            isMiniScreen={isMiniScreen}
            setIsMiniScreen={setIsMiniScreen}
            isChat={isTrialStatus}
            setIsChat={() => {}}
            phoneNumber={trialInfo.phoneNumber}
            trialInfo={trialInfo}
            route={callValue && callValue.callData && callValue.callData.route}
            maximizeCall={maximizeCall}
          />
        )}
      </div>
    </div>
  );
};

export default MasterLayout;
